import { WINDOW } from "@utils/constants";
import { isExists, isPC, isTabletAndMobile, isMobile } from "@utils/validate";
// import Swiper from "swiper";

const Custom = function () {
  /**
   * handleSetPositionSliderArrow
   */
  this.handleSetPositionSliderArrow = () => {
    const EL_PRODUCT_SLIDER = ".product-slider";
    const EL_SLICK_ARROW = ".slick-arrow";
    const CLASS_NAME_RATIO = ".ratio";

    if (!isExists(EL_PRODUCT_SLIDER)) {
      return;
    }

    $(EL_PRODUCT_SLIDER).on("init", function (e, slick) {
      const productThumbHeight = slick.$slider.find(CLASS_NAME_RATIO).height();
      slick.$slider.find(EL_SLICK_ARROW).css("top", productThumbHeight / 2);
    });
  };

  /**
   * handleToggleSidebar
   */
  this.handleToggleSidebar = () => {
    const sidebar = document.getElementById("sidebar");
    if (!isExists(sidebar)) {
      return;
    }
    isPC() ? $(sidebar).addClass("show") : $(sidebar).removeClass("show");
  };

  /**
   * handleQuantityProduct
   */
  this.handleQuantityProduct = () => {
    let el = $(".product-quantity"),
      elAdd = $(".add"),
      elSub = $(".sub"),
      max = parseInt(el.find("input").attr("max"));
    if (!isExists(el)) {
      return;
    }
    elAdd.on("click", function () {
      if ($(this).prev().val() < max) {
        $(this)
          .prev()
          .val(+$(this).prev().val() + 1);
      }
    });
    elSub.on("click", function () {
      if ($(this).next().val() > 1) {
        if ($(this).next().val() > 1)
          $(this)
            .next()
            .val(+$(this).next().val() - 1);
      }
    });
  };

  this.handleCollapseProductDetail = () => {
    const btnClose1 = ".readmore .close";
    const btnClose2 = ".js-close";

    if (isExists(btnClose1)) {
      $(btnClose1).on("click", function (e) {
        e.preventDefault();
        window.scrollTo({
          top: 0
        });
        setTimeout(function () {
          $("#info").collapse("hide");
          $(btnClose2).trigger("click");
        }, 700);
      });
    }

    if (isExists(btnClose2)) {
      $(btnClose2).on("click", function (e) {
        e.preventDefault();
        const $this = $(this);
        checkCollapse($this);
      });
    }
    function checkCollapse(target) {
      return target.hasClass("collapsed")
        ? target.text("Xem chi tiết »")
        : target.text("Thu gọn »");
    }
  };

  this.handleEqualHeight = (container, vari) => {
    const target = container;
    const item = $(target).find(".js-height-item");
    // $(item).style.height = "auto";
    var heightBet = 0;
    $.each(item, function (i, val) {
      val.style.height = "auto";
      const height = val.clientHeight;
      if (height > heightBet) {
        heightBet = height;
      }
    });
    $.each(item, function (i, el) {
      if (isMobile()) {
        vari === false ? (el.style.height = "auto") : (el.style.height = heightBet + "px");
      } else {
        el.style.height = heightBet + "px";
      }
      if (i == item.length) {
        heightBet = 0;
      }
    });
  };

  this.handleValidator = () => {
    const forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  };

  this.handleTodoSlide = () => {
    let el = document.querySelector(".todo-slider");
    if (!isExists(el)) {
      return;
    }
    const slides = el.querySelectorAll(".todo-slider .swiper-slide");
    const titles = Array.from(slides).map(slide => slide.getAttribute("data-title"));
    const link = Array.from(slides).map(slide => slide.getAttribute("data-link"));
    const images = Array.from(slides).map(slide => slide.getAttribute("data-img"));
    const texts = Array.from(slides).map(slide => slide.getAttribute("data-text"));

    const swiper = new Swiper(el, {
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      speed: 1000,
      freeMode: false,
      pagination: {
        el: ".section-todo-ctn .swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          // Prevent Swiper's pagination click handler from intercepting anchor clicks
          // by stopping propagation on the anchor itself. Also add rel for security.
          return `<div class="${className}">
            <a href="${
              link[index] || "#"
            }" target="_blank" rel="noopener noreferrer" class="todo-logo" onclick="event.stopPropagation();"><img src="${
            images[index]
          }" alt="${titles[index]}" /></a>
            <p class="todo-title">${titles[index]}</p>
            <p class="todo-text">${texts[index]}</p>
            </div>`;
        }
      },
      on: {
        click(event) {
          swiper.slideTo(this.clickedIndex);
        }
      }
    });
  };

  this.handleAboutSlide = () => {
    let el = document.querySelector("#about-slider");
    if (!isExists(el)) {
      return;
    }
    const slides = el.querySelectorAll("#about-slider .swiper-slide");
    const titles = Array.from(slides).map(slide => slide.getAttribute("data-title"));

    new Swiper(el, {
      grabCursor: true,
      loop: true,
      centeredSlides: true,
      slidesPerView: "auto",
      speed: 1000,
      freeMode: false,
      // Navigation arrows
      pagination: {
        el: ".about-slider-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return `<div class=${className}>
            <span>${titles[index]}</span>
            </div>`;
        }
      }
    });
  };

  this.handleLeaderSlide = () => {
    let el = document.querySelector("#leader-slider");
    if (!isExists(el)) {
      return;
    }
    new Swiper(el, {
      grabCursor: true,
      loop: true,
      slidesPerView: "auto",
      speed: 1000,
      freeMode: false,
      navigation: {
        nextEl: ".b-leadership__link"
      }
    });
  };
  // this.handleProjectTopSlide = () => {
  //   let el = document.querySelector("#projectTop");

  //   if (!isExists(el)) {
  //     return;
  //   }
  //   new Swiper(el, {
  //     loop: true,
  //     slidesPerView: 1,
  //     speed: 1000,
  //     navigation: {
  //       nextEl: ".project-top-list__next",
  //       prevEl: ".project-top-list__prev"
  //     }
  //   });
  //   if (isPC()) {
  //     el.swiper.destroy(true, true);
  //   }
  //   WINDOW.on("resize", function () {
  //     if (isPC()) {
  //       if (!el.swiper) return;
  //       el.swiper.destroy(true, true);
  //     } else {
  //       el.swiper = new Swiper(el, {
  //         loop: true,
  //         slidesPerView: 1,
  //         speed: 1000,
  //         navigation: {
  //           nextEl: ".project-top-list__next",
  //           prevEl: ".project-top-list__prev"
  //         }
  //       });
  //     }
  //   });
  //   // this.destroyElement = () => {
  //   //   if (el && el.swiper) {
  //   //     el.swiper.destroy(true, true);
  //   //   }
  //   // };
  // };

  this.handleSelectCustomize = () => {
    let el = document.querySelector(".js-select");
    if (!isExists(el)) {
      return;
    }
    $(".js-select").each(function () {
      var $this = $(this),
        numberOfOptions = $(this).children("option").length;

      var selectedOption = $this.children("option:selected");

      $this.addClass("js-select-hidden");
      $this.wrap('<div class="js-select-wrap"></div>');
      $this.after('<div class="js-select-styled"></div>');

      var $styledSelect = $this.next("div.js-select-styled");
      if (!selectedOption.length) {
        $styledSelect.text($this.children("option").eq(0).text());
      } else {
        $styledSelect.text(selectedOption.text());
      }

      var $list = $("<ul />", {
        class: "js-select-options"
      }).insertAfter($styledSelect);

      for (var i = 0; i < numberOfOptions; i++) {
        $("<li />", {
          text: $this.children("option").eq(i).text(),
          rel: $this.children("option").eq(i).val()
        }).appendTo($list);
        if ($this.children("option").eq(i).is(":selected")) {
          $('li[rel="' + $this.children("option").eq(i).val() + '"]').addClass("is-selected");
        }
      }

      var $listItems = $list.children("li");

      $styledSelect.click(function (e) {
        e.stopPropagation();
        $("div.js-select-styled.active")
          .not(this)
          .each(function () {
            $(this).removeClass("active").next("ul.js-select-options").hide();
          });
        $(this).toggleClass("active").next("ul.js-select-options").toggle();
      });

      $listItems.click(function (e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass("active");
        $this.val($(this).attr("rel"));
        $list.find("li.is-selected").removeClass("is-selected");
        $list.find('li[rel="' + $(this).attr("rel") + '"]').addClass("is-selected");
        $list.hide();
        // console.log($this.val());
      });

      $(document).click(function () {
        $styledSelect.removeClass("active");
        $list.hide();
      });
    });
  };

  this.handleVideoAspectRatio = () => {
    const video = $(".main-slider-video iframe");

    if (!isExists(video)) {
      return;
    }
    const aspectRatio = 1.78;

    const paddingWidth = $(".main-slider-video").attr("data-padding");

    const videoHeight = window.innerHeight;
    const newWidth = videoHeight * aspectRatio + Number(paddingWidth);
    const newHeight = videoHeight + 500;
    const halfNewWidth = newWidth / 2;
    const halfNewHeight = newHeight / 2;

    // Define the new width and centrally align the iframe
    video.css({
      width: newWidth + "px",
      height: newHeight + "px",
      left: "50%",
      "margin-left": "-" + halfNewWidth + "px",
      top: "50%",
      "margin-top": "-" + halfNewHeight + "px"
    });
  };

  this.handleReadMore = () => {
    const btnViewMore = $(".btn-view-more");
    if (!isExists(btnViewMore)) return;

    btnViewMore.on("click", function (e) {
      e.preventDefault();
      const $this = $(this);
      const $fulltext = $this.closest(".readmore").siblings(".fulltext");

      $fulltext.toggleClass("expanded");
      $this.toggleClass("expanded");

      if ($fulltext.hasClass("expanded")) {
        $this.text("Thu gọn");
      } else {
        $this.text("Xem thêm");
        // Scroll back to start of content if needed
        const offset = $fulltext.offset().top - 100;
        $("html, body").animate(
          {
            scrollTop: offset
          },
          300
        );
      }
    });
  };

  this.handleToggleSocial = () => {
    const TRIGGER = ".js-social-share";
    const CONTAINER = ".js-social-share-ctn, .js-social-ctn";

    if (!isExists(TRIGGER)) return;

    // Click outside to close any open social containers
    $(document).on("click", function (e) {
      if (!$(e.target).closest(TRIGGER + ", " + CONTAINER).length) {
        $(CONTAINER).removeClass("show");
      }
    });

    // Desktop: show on hover, keep visible while hovering the container
    if (isPC()) {
      $(TRIGGER).each(function () {
        const $tr = $(this);
        // target container usually is a sibling ul
        const $ctn = $tr.siblings(".js-social-share-ctn, .js-social-ctn").first();
        if (!$ctn.length) return;

        $tr.on("mouseenter", function () {
          $ctn.stop(true, true).fadeIn(150).addClass("show");
        });
        $tr.on("mouseleave", function () {
          // use small timeout to allow moving to the container
          setTimeout(function () {
            if (!$ctn.is(":hover")) {
              $ctn.stop(true, true).fadeOut(150).removeClass("show");
            }
          }, 50);
        });

        $ctn.on("mouseenter", function () {
          $(this).stop(true, true).show().addClass("show");
        });
        $ctn.on("mouseleave", function () {
          $(this).stop(true, true).fadeOut(150).removeClass("show");
        });
      });
    } else {
      // Mobile / touch: toggle on click
      $(document).on("click", TRIGGER, function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $tr = $(this);
        const $ctn = $tr.siblings(".js-social-share-ctn, .js-social-ctn").first();
        if (!$ctn.length) return;
        // close other open containers
        $(CONTAINER).not($ctn).removeClass("show");
        $ctn.toggleClass("show");
      });
    }
  };

  this.handleViewFullGallery = () => {
    const btnViewFull = $(".btn-view-full");
    if (!isExists(btnViewFull)) return;

    btnViewFull.on("click", function (e) {
      e.preventDefault();
      // Mở Fancybox tại hình thứ 6 (index 5) trong gallery
      $('[data-fancybox="rent-gallery"]').eq(5).trigger("click");
    });
  };

  /**
   * handleBuildingGallerySlider
   * Initialize slick slider for .building-gallery-inner only when viewport < 992px
   */
  this.handleBuildingGallerySlider = () => {
    const selector = ".building-gallery-inner";

    if (!isExists(selector)) return;

    const $el = $(selector);
    let resizeTimer = null;

    const initOrDestroy = () => {
      // enable slick only on screens smaller than 992px
      if (window.innerWidth < 992) {
        if (!$el.hasClass("slick-initialized")) {
          $el.slick({
            centerMode: true,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            infinite: true,
            mobileFirst: true,
            // center the active slide and show peek of prev/next
            // centerPadding of 10% on each side => center slide approx 80% width
            centerPadding: "10%",
            responsive: [
              {
                breakpoint: 600,
                settings: {
                  centerMode: false,
                  slidesToShow: 2,
                  centerPadding: 0
                }
              }
            ]
          });
        }
      } else {
        if ($el.hasClass("slick-initialized")) {
          $el.slick("unslick");
        }
      }
    };

    // initial run
    initOrDestroy();

    // debounce resize
    WINDOW.on("resize", function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initOrDestroy();
      }, 150);
    });
  };

  this.init = function () {
    let self = this;
    self.handleSetPositionSliderArrow();
    self.handleToggleSidebar();
    self.handleQuantityProduct();
    self.handleCollapseProductDetail();
    self.handleValidator();
    self.handleTodoSlide();
    self.handleAboutSlide();
    self.handleLeaderSlide();
    self.handleSelectCustomize();
    self.handleReadMore();
    self.handleViewFullGallery();
    self.handleBuildingGallerySlider();
    this.handleToggleSocial();
    // self.handleProjectTopSlide();

    $('[data-fancybox="images"]').fancybox({
      thumbs: {
        autoStart: true
      }
    });
    $('[data-fancybox="rent-gallery"]').fancybox({
      thumbs: {
        autoStart: true
      }
    });

    WINDOW.on("load", function () {
      self.handleEqualHeight("#product-slider", true);
      self.handleEqualHeight("#customer-slider", false);
      self.handleVideoAspectRatio();
    });
    WINDOW.on("resize", function () {
      setTimeout(function () {
        self.handleEqualHeight("#product-slider", true);
        self.handleEqualHeight("#customer-slider", false);
      });
      setTimeout(function () {
        self.handleVideoAspectRatio();
      }, 1000);
      // if (isPC()) {
      //   self.destroyElement();
      // }
    });

    WINDOW.resize(function () {
      self.handleSetPositionSliderArrow();
      !isTabletAndMobile && self.handleToggleSidebar();
    });
  };
  return this.init();
};
export default Custom;
